import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './app/App'
import 'normalize.css'
import 'react-super-treeview/dist/style.scss'
import { Buffer } from 'buffer'

import './styles/App.scss'

// Polyfill Buffer for browser
if (typeof window !== 'undefined') {
  ;(window as any).Buffer = Buffer
  ;(globalThis as any).Buffer = Buffer
}

ReactDOM.render(<App />, document.querySelector('#root') as HTMLElement)
